import { render, staticRenderFns } from "./page-content-type-faq.vue?vue&type=template&id=3c99c15b&scoped=true"
import script from "./page-content-type-faq.vue?vue&type=script&lang=js"
export * from "./page-content-type-faq.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-faq.vue?vue&type=style&index=0&id=3c99c15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99c15b",
  null
  
)

export default component.exports